import { gql } from "@apollo/client";

export const createDistributionMutation = gql`
    mutation createDistribution(
        $releaseId: Int!
        $clientId: Int!
        $territoryId: Int!
        $distributionFileTypeId: Int!
        $releaseDate: DateTime
        $tracksFormat: [Int]!
        $extendedDetails: ExtendedReleaseDetailsInput
    ) {
        distribute(
            releaseId: $releaseId
            clientId: $clientId
            territoryId: $territoryId
            distributeTypeId: $distributionFileTypeId
            releaseDate: $releaseDate
            tracksformat: $tracksFormat
            extendedDetails: $extendedDetails
        )
    }
`;

// bulk never throws for a single bad release: every release (or video) it could not queue comes back as a
// failed result, so the caller has to read `results` to know whether anything actually started
export const createBulkDistributionsMutation = gql`
    mutation createBulkDistributions(
        $releasesIds: [Int]!
        $clientId: Int!
        $territoryId: Int!
        $distributionFileTypeId: Int!
        $releaseDate: DateTime
        $tracksFormat: [Int]!
        $extendedDetails: ExtendedReleaseDetailsInput
    ) {
        bulkDistribute(
            releaseIds: $releasesIds
            clientId: $clientId
            territoryId: $territoryId
            distributeTypeId: $distributionFileTypeId
            releaseDate: $releaseDate
            tracksformat: $tracksFormat
            extendedDetails: $extendedDetails
        ) {
            message
            results {
                releaseId
                videoId
                title
                success
                message
            }
        }
    }
`;

// standalone video distribution spawns one job and one XML per video; it reuses `distribute` with
// `videosId` set instead of `tracksformat`, which the backend branches on to skip the audio-only
// file/stereo-track validation and create a per-video DistributionJob
export const createVideoDistributionMutation = gql`
    mutation createVideoDistribution(
        $releaseId: Int!
        $clientId: Int!
        $territoryId: Int!
        $distributeTypeId: Int!
        $videosId: [Int]!
        $releaseDate: DateTime
    ) {
        distribute(
            releaseId: $releaseId
            clientId: $clientId
            territoryId: $territoryId
            distributeTypeId: $distributeTypeId
            videosId: $videosId
            releaseDate: $releaseDate
        )
    }
`;

// bulk takes no video ids: `isVideoOnly` tells the backend to distribute every video of every
// selected release instead
export const createBulkVideoDistributionsMutation = gql`
    mutation createBulkVideoDistributions(
        $releasesIds: [Int]!
        $clientId: Int!
        $territoryId: Int!
        $distributeTypeId: Int!
        $releaseDate: DateTime
    ) {
        bulkDistribute(
            releaseIds: $releasesIds
            clientId: $clientId
            territoryId: $territoryId
            distributeTypeId: $distributeTypeId
            releaseDate: $releaseDate
            isVideoOnly: true
        ) {
            message
            results {
                releaseId
                videoId
                title
                success
                message
            }
        }
    }
`;

export const deleteDistributionMutation = gql`
    mutation deleteDistribution($id: Int!) {
        deleteDistributionJob(jobId: $id)
    }
`;

export const retryFailedDistributionMutation = gql`
    mutation retryFailedDistribution($id: Int!) {
        retryDistributionJob(jobId: $id)
    }
`;

export const takeDownAppleDistributionMutation = gql`
    mutation takedownDistribution($id: Int!, $commandMode: CommandMode!) {
        takedownDistribution(jobId: $id, commandMode: $commandMode)
    }
`;

export const editDistributionMetadataMutation = gql`
    mutation DistributeMetadataUpdate($releaseId: Int!, $clientId: Int!, $territoryId: Int!, $jobId: Int!) {
        distributeMetadataUpdate(releaseId: $releaseId, clientId: $clientId, territoryId: $territoryId, jobId: $jobId)
    }
`;

export const editDistributeMediaFilesMutation = gql`
    mutation DistributeAssetsUpdate($releaseId: Int!, $clientId: Int!, $territoryId: Int!, $jobId: Int!) {
        distributeAssetsUpdate(releaseId: $releaseId, clientId: $clientId, territoryId: $territoryId, jobId: $jobId)
    }
`;
